import React from "react";

const SelectTextInput = ({ options, label = "Select Duration", unit, setUnit, value, setValue }) => {
  // Handle unit change
  const handleUnitChange = (e) => {
    const selectedOption = options.find(option => option.value === e.target.value) || options[0];
    setUnit(e.target.value);  // Set the selected unit

    // If the selected option has `hideInput` as true, set the value to null
    if (selectedOption.hideInput) {
      setValue(null);
    } else {
      setValue("");  // Reset the numeric value when the unit changes
    }
  };

  const handleValueChange = (e) => {
    setValue(e.target.value);  // Update the numeric value
  };

  // Helper function to display singular/plural units
  const getUnitLabel = () => {
    const selectedOption = options?.find(opt => opt.value === parseInt(unit)) || options[0];
    if (!selectedOption) return ""; // Return empty if no unit is selected

    // Check if value is 1, then display singular label (without "s")
    return value === "1"
      ? selectedOption.label.replace("(s)", "")
      : selectedOption.label;
  };

  const selectedOption = options?.find(opt => opt.value === parseInt(unit)) || options[0];

  return (
    <div className="">
      {/* Select dropdown for duration units */}
      <div className="flex flex-col space-y-2">
        <label className="text-gray-700 font-medium">{ label }</label>
        <select
          value={unit}
          onChange={handleUnitChange}
          className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="" disabled>Select a unit</option>
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Text input that appears when a unit is selected and hideInput is false */}
      {selectedOption && !selectedOption.hideInput ? (
        <div className="flex flex-col space-y-2">
          <label className="text-gray-700 font-medium">
            Enter the {getUnitLabel()}
          </label>
          <input
            type="number"
            value={value || ""}
            onChange={handleValueChange}
            placeholder="Enter a number"
            className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      ) : null}
    </div>
  );
};

export default SelectTextInput;
